// Helper para gerar URL de imagem correta
// Em produção, as imagens são servidas diretamente pelo domínio (não pela API)
// Em desenvolvimento, usa localhost:5000
// Ative quando o backend servir versões .webp (menor peso que PNG/JPEG)
export const PREFER_WEBP = false;

// Opção preferWebP: se true, troca extensão .png/.jpg/.jpeg por .webp (backend deve servir os .webp)
export const getImageUrl = (imagePath, options = {}) => {
  if (!imagePath) return null;

  const preferWebP = options.preferWebP ?? PREFER_WEBP;
  let path = imagePath;
  if (preferWebP && /\.(png|jpe?g)$/i.test(imagePath)) {
    path = imagePath.replace(/\.(png|jpe?g)$/i, '.webp');
  }

  // Se já começar com http:// ou https://, retornar como está (após possível troca para .webp)
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  // Sempre usar window.location.origin se disponível (funciona em produção e desenvolvimento)
  if (typeof window !== 'undefined' && window.location) {
    const normalized = path.startsWith('/') ? path : `/${path}`;
    return `${window.location.origin}${normalized}`;
  }

  // Fallback: usar variável de ambiente ou localhost
  const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
  const serverBaseURL = baseURL.replace('/api', '');
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${serverBaseURL}${normalized}`;
};
